import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';

PouchDB.plugin(PouchDBFind);

// Bases de données locales
export const prodDb = new PouchDB('products');
export const subDb = new PouchDB('substances');
export const userDb = new PouchDB('users');
export const localDataDb = new PouchDB('localData');

// Fonction pour obtenir une base de données par nom
export const getLocalDB = (name) => {
    return new PouchDB(name);
};

// Configuration des index pour la recherche
const setupIndexes = async () => {
    try {
        // Index pour les produits
        await prodDb.createIndex({
            index: {
                fields: ['name', 'DCI', 'laboratoire']
            }
        });

        // Index pour les substances
        await subDb.createIndex({
            index: {
                fields: ['name', 'DCI']
            }
        });

        // Index pour les utilisateurs
        await userDb.createIndex({
            index: {
                fields: ['email']
            }
        });

        // Index pour les données locales (équivalences, interactions, etc.)
        await localDataDb.createIndex({
            index: {
                fields: ['type', 'name', 'source']
            }
        });

    } catch (error) {}
};

// Initialisation des bases
setupIndexes().catch(() => {});

export default {
    prodDb,
    subDb,
    userDb,
    localDataDb
};